import type { HocuspocusProvider } from "@hocuspocus/provider";

type Awareness = NonNullable<HocuspocusProvider["awareness"]>;

const cursorOwners = new WeakMap<Awareness, Awareness>();

export const createCursorAwareness = (awareness: Awareness): Awareness => {
  const editorAwareness: Awareness = Object.create(awareness);
  editorAwareness.setLocalStateField = (field, value) => {
    if (field === "cursor") {
      // Repeated pinned-topic editors share a fragment, but only its active editor may clear the cursor.
      if (value === null) {
        if (cursorOwners.get(awareness) !== editorAwareness) return;
        cursorOwners.delete(awareness);
      } else {
        cursorOwners.set(awareness, editorAwareness);
      }
    }
    awareness.setLocalStateField(field, value);
  };
  return editorAwareness;
};
